
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const WorkTypeEleMasterTableDataAPI = createAsyncThunk("WorkTypeEleMasterTableData", async ({ data }) => {
    const {
        M_ELEC_WorkID,
        M_ELEC_WorkTypeID,
        M_ELEC_WorkSubTypeID,
        WorkName,
        M_UserID,
        token,
        From,
        To,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Work_Select?M_ELEC_WorkID=${M_ELEC_WorkID}&M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&M_ELEC_WorkSubTypeID=${M_ELEC_WorkSubTypeID}&WorkName=${WorkName}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkTypeEleMasterTableDataSlice = createSlice({
    name: "WorkTypeEleMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkTypeEleMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkTypeEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WorkTypeEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WorkTypeEleMasterTableDataReducer = WorkTypeEleMasterTableDataSlice.reducer



// Excel Get Table Data
export const ExcelWorkTypeEleMasterTableDataAPI = createAsyncThunk("ExcelWorkTypeEleMasterTableData", async ({ data }) => {
    const {
        M_ELEC_WorkID,
        M_ELEC_WorkTypeID,
        M_ELEC_WorkSubTypeID,
        WorkName,
        M_UserID,
        token,
        From,
        To,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Work_Select?M_ELEC_WorkID=${M_ELEC_WorkID}&M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&M_ELEC_WorkSubTypeID=${M_ELEC_WorkSubTypeID}&WorkName=${WorkName}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ExcelWorkTypeEleMasterTableDataSlice = createSlice({
    name: "ExcelWorkTypeEleMasterTableData",
    initialState: {
        isExportLoading: false,
        ExceltableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ExcelWorkTypeEleMasterTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(ExcelWorkTypeEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExceltableData = action.payload;
        });
        builder.addCase(ExcelWorkTypeEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExceltableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ExcelWorkTypeEleMasterTableDataReducer = ExcelWorkTypeEleMasterTableDataSlice.reducer

// InsertUpdate Table Data

export const Post_M_ELEC_Work_InsertUpdateAPI = createAsyncThunk("Post_M_ELEC_Work_InsertUpdate", async ({ data }) => {
    const {
        M_ELEC_WorkID,
        M_ELEC_WorkTypeID,
        M_ELEC_WorkSubTypeID,
        WorkName,
        PenaltyPeriod,
        Benchmark,
        Benchmark_In_Days,
        PenaltyPeriodHours,
        PenaltyAmount,
        M_UserID,
        Flag,
        token,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    // if (Flag == "Update") {
    //     formdata.append("M_ELEC_PoleID", M_ELEC_PoleID);
    // }
    formdata.append("M_ELEC_WorkID", M_ELEC_WorkID);
    formdata.append("M_ELEC_WorkTypeID", M_ELEC_WorkTypeID);
    formdata.append("M_ELEC_WorkSubTypeID", M_ELEC_WorkSubTypeID);
    formdata.append("WorkName", WorkName);
    formdata.append("PenaltyPeriod", PenaltyPeriod);
    formdata.append("Benchmark", Benchmark);
    formdata.append("Benchmark_In_Days", Benchmark_In_Days);
    formdata.append("PenaltyPeriodHours", PenaltyPeriodHours);
    formdata.append("PenaltyAmount", PenaltyAmount);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)

    let url
    url = `${BaseUrl}/Electrical/Post_M_ELEC_Work_InsertUpdate`

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const Post_M_ELEC_Work_InsertUpdateSlice = createSlice({
    name: "Post_M_ELEC_Work_InsertUpdate",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Post_M_ELEC_Work_InsertUpdateAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Post_M_ELEC_Work_InsertUpdateAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Post_M_ELEC_Work_InsertUpdateAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const Post_M_ELEC_Work_InsertUpdateReducer = Post_M_ELEC_Work_InsertUpdateSlice.reducer



// Delete Table Data

export const M_ELEC_Work_DeleteAPI = createAsyncThunk("M_ELEC_Work_Delete", async ({ data }) => {
    const {
        M_ELEC_WorkID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_WorkID", M_ELEC_WorkID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/M_ELEC_Work_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const M_ELEC_Work_DeleteSlice = createSlice({
    name: "M_ELEC_Work_Delete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_ELEC_Work_DeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(M_ELEC_Work_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(M_ELEC_Work_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const M_ELEC_Work_DeleteReducer = M_ELEC_Work_DeleteSlice.reducer